import { FormSearchParams } from "@aipb/gulliver/castor/model";
import {
  FIELDS_MAPPER,
  HIGHLIGHTING_MAPPER,
  SEARCH_FACET_MAPPER,
  SEARCH_QUERY_PARAMS_MAPPER,
  SEARCH_SORT_MAPPER,
  SPATIAL_FILTER_MAPPER
} from './castor-mappers';
import { CastorMapper } from './mapper';

export class FormSearchMapper implements CastorMapper<FormSearchParams> {
  map(o: FormSearchParams): { [key: string]: any } {
    return {
      ...o,
      query: JSON.stringify(
        o.query.map((q) => ({
          fieldId: q.fieldId,
          queryRow: q.queryRow,
          logOp: q.logOp
        }))
      ),
      ...HIGHLIGHTING_MAPPER.map(o.highlighting),
      ...SEARCH_SORT_MAPPER.map(o.sort),
      ...SEARCH_FACET_MAPPER.map(o.facet),
      ...FIELDS_MAPPER.map(o.fields),
      ...SEARCH_QUERY_PARAMS_MAPPER.map(o.queryParams),
      ...SPATIAL_FILTER_MAPPER.map(o.spatialFilter)
    };
  }
}

export const FORM_SEARCH_MAPPER = new FormSearchMapper();
